import { Fragment, useContext, useState } from "react";
import { CouponPopup } from "./CouponPopup";
import { GlobalContext } from "../../Context/GlobalContext";
import { ConvertToFloat } from "../../Layout/Common/common";

export const Coupon = () => {
  const [coupon, setCoupon] = useState(null);
  const { shippingCost, promoCode, setPromoCode } = useContext(GlobalContext);

  const handleUpdateCoupon = (promo) => {
    setCoupon(true);
    setPromoCode(promo);
  };

  const handleClearCoupon = () => {
    setCoupon(false);
    setPromoCode(null);
  };

  return (
    <Fragment>
      <div className="order-summary-list">
        {promoCode ? (
          <Fragment>
            <div className="orderCoupon">
              <p>Coupon Code</p>
              <div className="added-coupon">
                <div className="added-coupon-info">
                  <i className="fa-solid fa-tag" />
                  {promoCode.shipcode}
                </div>
                <button type="button" onClick={handleClearCoupon}>
                  <i className="fa-solid fa-circle-xmark" />
                </button>
              </div>
            </div>
            {promoCode.shipcode == "DELFREE" && shippingCost && shippingCost != "TBA" && (
              <span className="add-coupon" data-bs-toggle="modal" data-bs-target="#addCoupon">
                -${ConvertToFloat(shippingCost)}
              </span>
            )}
          </Fragment>
        ) : (
          <Fragment>
            <div>
              <p>Coupon Code</p>
            </div>
            <span className="add-coupon" data-bs-toggle="modal" data-bs-target="#addCoupon">
              Add Coupon
            </span>
          </Fragment>
        )}
      </div>
      <CouponPopup handleUpdateCoupon={handleUpdateCoupon} />
    </Fragment>
  );
};
